.participantInfoRow {
  color: var(--darkGray);
  display: flex;
  justify-content: space-between;

  p {
    margin-bottom: 0;
  }
}

.emailSelection {
  margin-top: 0.2em;
}

.emailSelectionTitle {
  color: var(--darkGray);
  font-weight: 300;
  font-size: 1.125em;
  margin-bottom: 0.2em;

  p {
    margin-bottom: 0;
  }
}

.emailSelectionRow {
  margin-bottom: 0.2em;
}

.emailLabel {
  padding-left: 0.75em !important;
  vertical-align: top !important;
}

.emailSource {
  font-size: 0.875em;
  padding-left: 0.5em;
}
